




// import { authenticatePhoneNo, verificationCall, fetchUserData } from "../service/authService";

// export const AUTH_START = "AUTH_START";
// export const AUTH_SUCCESS = "AUTH_SUCCESS";
// export const AUTH_FAILURE = "AUTH_FAILURE";

// export const LOAD_USER_DATA_SUCCESS = "LOAD_USER_DATA_SUCCESS";
// export const LOAD_USER_DATA_FAILURE = "LOAD_USER_DATA_FAILURE";

// // Action to load user data by phone number
// export const loadUserData = (phoneNumber) => async (dispatch) => {
//   try {
//       const response = await fetchUserData(phoneNumber);
      
//       dispatch({
//           type: LOAD_USER_DATA_SUCCESS,
//           payload: {
//               ...response,
//               correctPhoneFormat: response.correctPhoneFormat,
//           },
//       });
//   } catch (error) {
//       console.error("Error loading user data:", error);
//       dispatch({
//           type: LOAD_USER_DATA_FAILURE,
//           payload: error,
//       });
//   }
// };


// // Authentication actions
// export const startAuthentication = () => ({
//   type: AUTH_START,
// });

// export const authenticationSuccess = (data) => ({
//   type: AUTH_SUCCESS,
//   payload: data,
// });

// export const authenticationFailure = (error) => ({
//   type: AUTH_FAILURE,
//   payload: error,
// });
// export const setUserData = (userData) => {
//   return {
//       type: "SET_USER_DATA",
//       payload: userData,
//   };
// };
// export const authenticate = (phoneNumber) => async (dispatch) => {
//   dispatch(startAuthentication());
//   try {
//     const isValid = await authenticatePhoneNo(phoneNumber);
//     if (!isValid) {
//       throw { message: "Invalid phone number." };
//     }

//     const otpResponse = await verificationCall(phoneNumber);
//     dispatch(authenticationSuccess(otpResponse));
//     return { success: true, data: otpResponse };
//   } catch (error) {
//     dispatch(authenticationFailure(error));
//     return { success: false, error };
//   }
// };

// export const resendOtp = (phoneNumber) => async (dispatch) => {
//   try {
//     const resendOtpResponse = await verificationCall(phoneNumber, true);
//     return { success: true, data: resendOtpResponse };
//   } catch (error) {
//     console.error("Error resending OTP:", error);
//     return { success: false, error };
//   }
// };


import { authenticatePhoneNo, verificationCall, fetchUserData } from "../service/authService";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const RESTORE_SESSION = "RESTORE_SESSION"; 
export const LOAD_USER_DATA_SUCCESS = "LOAD_USER_DATA_SUCCESS";
export const LOAD_USER_DATA_FAILURE = "LOAD_USER_DATA_FAILURE"; 
export const restoreSession = () => (dispatch) => {
  const phoneNumber = localStorage.getItem("phoneNumber");
  const userData = localStorage.getItem("userData");
  const sentOtp = localStorage.getItem("sentOtp");
  
  if (phoneNumber) {
    let parsedUserData = null;
    
    // Safely parse userData
    if (userData && userData !== "undefined" && userData !== "null") {
      try {
        parsedUserData = JSON.parse(userData);
      } catch (error) {
        console.warn("Failed to parse userData from localStorage:", error);
        // Clear corrupted data
        localStorage.removeItem("userData");
      }
    }
    
    dispatch({
      type: RESTORE_SESSION,
      payload: {
        phoneNumber,
        userData: parsedUserData,
        sentOtp: sentOtp || null
      }
    });
    return true;
  }
  return false;
};
export const loadUserData = (phoneNumber) => async (dispatch) => {
  try {
      const response = await fetchUserData(phoneNumber);
      
      dispatch({
          type: LOAD_USER_DATA_SUCCESS,
          payload: {
              ...response,
              correctPhoneFormat: response.correctPhoneFormat,
          },
      });
  } catch (error) {
      console.error("Error loading user data:", error);
      dispatch({
          type: LOAD_USER_DATA_FAILURE,
          payload: error,
      });
  }
};
export const startAuthentication = () => ({
  type: AUTH_START,
});
export const authenticationSuccess = (data) => ({
  type: AUTH_SUCCESS,
  payload: data,
});
export const authenticationFailure = (error) => ({
  type: AUTH_FAILURE,
  payload: error,
});
export const setUserData = (userData) => {
  return {
      type: "SET_USER_DATA",
      payload: userData,
  };
};
export const logout = () => (dispatch) => {
  localStorage.removeItem("phoneNumber");
  localStorage.removeItem("userData");
  localStorage.removeItem("sentOtp");
  
  dispatch({
    type: "LOGOUT"
  });
};
export const authenticate = (phoneNumber) => async (dispatch) => {
  dispatch(startAuthentication());
  try {
    const isValid = await authenticatePhoneNo(phoneNumber);
    if (!isValid) {
      throw { message: "Invalid phone number." };
    }
    const otpResponse = await verificationCall(phoneNumber);
    dispatch(authenticationSuccess(otpResponse));
    return { success: true, data: otpResponse };
  } catch (error) {
    dispatch(authenticationFailure(error));
    return { success: false, error };
  }
};
export const resendOtp = (phoneNumber) => async (dispatch) => {
  try {
    const resendOtpResponse = await verificationCall(phoneNumber, true);
    return { success: true, data: resendOtpResponse };
  } catch (error) {
    console.error("Error resending OTP:", error);
    return { success: false, error };
  }
};